
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/protocols",
      function () {
        return require("private-next-pages/protocols/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/protocols"])
      });
    }
  